import React from 'react';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { ReactComponent as HomeIcon } from '../svg/home.svg';
import Layout from '../pages/Layout';
import { getAllTitles } from './Catalog';
import Loading from '../components/Loading';
import { useSelector } from 'react-redux';

const Home = (props) => {
    const session = useSelector((state) => state.session);
    const [urgentTitles, setUrgentTitles] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);

    React.useEffect(() => {
        const getUrgentTitles = async () => {
            setIsLoading(true);
            try {
                let urgentTitlesResp = await getAllTitles({
                    status: 'incomplete',
                    vendors: `[${session.selectedVendor}]`
                });

                setUrgentTitles(
                    (urgentTitlesResp?.data?.results || [])
                        .filter((title) => title.active)
                        .sort((a, b) => {
                            return (
                                new Date(a.strict_onsale_date?.replace(/-/g, '/')) -
                                new Date(b.strict_onsale_date?.replace(/-/g, '/'))
                            );
                        })
                );
            } catch (e) {
                console.error(e);
                toast.error('There was an error getting a list of your incomplete titles');
            }
            setIsLoading(false);
        };
        if (session.selectedVendor) {
            getUrgentTitles();
        }
    }, [session.selectedVendor]);

    return (
        <Layout>
            <div className="card card-flat mb-5">
                <div className="card-body">
                    <div className="mb-2">
                        <HomeIcon stroke="#77D5F3" width="1em" height="1em" style={{ fontSize: '3rem' }} />
                    </div>
                    <p>
                        <strong>Welcome to Passport!</strong>
                    </p>
                    <p>
                        This is your central location to manage your audiobook catalog, monitor the performance of your
                        audiobooks, and change account settings. Questions? We are here to help, please reach out to our {' '}
                        <a
                            href="mailto:pub-support@inaudio.com"
                        >
                            Support Team
                        </a>
                        .
                    </p>

                </div>
            </div>
            {isLoading && <Loading />}
            {!isLoading && (
                <>
                    <p>
                        You currently have{' '}
                        <span className="text-danger font-weight-bold">{urgentTitles.length} incomplete</span>{' '}
                        {`${urgentTitles.length === 1 ? 'title' : 'titles'}`}.{' '}
                        {urgentTitles.length > 0 && (
                            <Link to="/catalog?statusFilter=incomplete">Manage incomplete titles.</Link>
                        )}
                    </p>
                    {urgentTitles.length > 0 && (
                        <>
                            <p>
                                These are titles where you previously submitted Metadata, but not Art and Audio. Please
                                ensure Art and Audio are submitted at least a week before your release date.
                            </p>
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Title</th>
                                            <th>Release Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {urgentTitles.map((title) => (
                                            <tr key={title.contentid}>
                                                <td>
                                                    <Link to={`/catalog/${title.id}/metadata`}>{title.title}</Link>
                                                </td>
                                                <td>{format(title.strict_onsale_date, 'MM/DD/YY')}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </>
            )}
        </Layout>
    );
};

export default Home;
